import React from 'react'
import styled from 'styled-components'

const Subtitle = styled.span.attrs({ className: 'typo-body-medium' })`
  text-align: center;
`
export default Subtitle
